// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as itemListData from '@/assets/data';

export const currentVersion = '0.0.3';
export function convertToCurrentVersion(dataObjectAnyVersion: any) {
	if (dataObjectAnyVersion.version === currentVersion) {
		return dataObjectAnyVersion;
	}

	if (!dataObjectAnyVersion.version) {
		dataObjectAnyVersion.version = '0.0.1';
		dataObjectAnyVersion.registeredMusic =
			dataObjectAnyVersion.registeredMusic.map((m: any) =>
				m === 'kk-db' ? 'kk-dandb' : m
			);
	}

	if (!dataObjectAnyVersion.donatedSea) {
		dataObjectAnyVersion.donatedSea = [];
		dataObjectAnyVersion.version = '0.0.2';
	}

	if (dataObjectAnyVersion.version === '0.0.2') {
		const version003: any = {
			version: '0.0.3',
			collection: {
				...(dataObjectAnyVersion.donatedBugs
					? { bug: dataObjectAnyVersion.donatedBugs }
					: {}),
				...(dataObjectAnyVersion.donatedFishes
					? { fish: dataObjectAnyVersion.donatedFishes }
					: {}),
				...(dataObjectAnyVersion.donatedSea
					? { sea: dataObjectAnyVersion.donatedSea }
					: {}),
				...(dataObjectAnyVersion.registeredMusic
					? { music: dataObjectAnyVersion.registeredMusic }
					: {}),
			},
			filters: {
				donated:
					dataObjectAnyVersion.filterSelection.donated === undefined
						? null
						: dataObjectAnyVersion.filterSelection.donated === 'true',
				endsBy:
					dataObjectAnyVersion.filterSelection.endsBy === undefined
						? null
						: parseInt(dataObjectAnyVersion.filterSelection.endsBy),
				availableBy:
					dataObjectAnyVersion.filterSelection.availableBy === undefined
						? null
						: parseInt(dataObjectAnyVersion.filterSelection.availableBy),
				hoursBy:
					dataObjectAnyVersion.filterSelection.hoursBy === undefined
						? null
						: parseInt(dataObjectAnyVersion.filterSelection.hoursBy),
			},
		};
		const fashion = [
			'tops',
			'bottoms',
			'dresses',
			'headwear',
			'accessories',
			'socks',
			'shoes',
			'bags',
			'umbrellas',
		];
		const fashionKeys: any = fashion.reduce(
			(p, c) => ({
				...p,
				...Object.keys(itemListData[c]).reduce(
					(ip, ic) => ({ ...ip, [ic]: c }),
					{}
				),
			}),
			{}
		);
		if (dataObjectAnyVersion.fashionSelected) {
			const fashionConverted: any = {};
			dataObjectAnyVersion.fashionSelected.forEach((f: string) => {
				const fashionKey = f.split(':')[0];
				const category = fashionKeys[fashionKey];
				if (!fashionConverted[category]) fashionConverted[category] = [];
				fashionConverted[category].push(f);
			});
			version003.collection = { ...version003.collection, ...fashionConverted };
		}

		dataObjectAnyVersion = version003;
	}

	return dataObjectAnyVersion;
}
